// extracted by mini-css-extract-plugin
export var linkText = "_px-0";